import { requestPasswordRecoveryUseCase } from '@identity/application/use-cases';
import type { PublicUseCases } from '@identity/composition/types';
import type { AuthHttpClientType } from '@identity/infrastructure/api';
import { createAuthApiRepository } from '@identity/infrastructure/repositories';

/**
 * Creates the use cases that authorize with nothing.
 *
 * They take no credential source, so they have nowhere to read a subject from: their events carry no
 * account, which is the only thing that can be said about a call nobody authorized.
 */
export const createPublicUseCases = (httpClient: AuthHttpClientType): PublicUseCases => ({
  requestPasswordRecovery: requestPasswordRecoveryUseCase(
    createAuthApiRepository({ httpClient, authorizer: 'none' }),
    'recovery',
  ),
});
